<template>
  <div class="login-line">
    <div class="modal login-line-modal">
      <button class="modal-close is-large" aria-label="close" @click="closeModal"></button>
      <div class="modal-background" @click="closeModal"></div>
      <div class="modal-card">
        <section class="modal-card-body">
          <div>
            <div>
              <!-- Step 1 -->
              <p class="title is-size-5 has-text-success has-text-left">{{ $t("login.step-1") }}</p>
              <div v-if="$store.getters.firstCode">
                <a
                  id="friend-button"
                  class="button is-success is-medium is-rounded"
                  v-clipboard:copy="$store.getters.firstCode"
                  v-clipboard:success="onCopyGoToLine"
                  @click="goToLine"
                >
                  <i class="fab fa-line fa-2x" />&nbsp;
                  <i class="fa fa-plus" />&nbsp;
                  <img src="../assets/logo-round-96.png" width="35" />
                </a>
              </div>

              <div v-if="!$store.getters.firstCode">
                <a class="button is-success is-medium is-rounded has-text-weight-semibold">
                  <i class="fas fa-spinner fa-spin"></i>
                </a>
              </div>

              <hr />
              <!-- Step 2 -->
              <p class="title is-size-5 has-text-success has-text-left">{{ $t("login.step-2") }}</p>
              <div v-if="$store.getters.firstCode">
                <a
                  id="first-code-btn"
                  class="button is-medium is-outlined is-link has-text-link has-text-weight-semibold is-rounded"
                  v-clipboard:copy="$store.getters.firstCode"
                  v-clipboard:success="onCopy"
                  v-if="blurButton"
                >{{$store.getters.firstCode}}</a>
              </div>
              <div v-if="!$store.getters.firstCode">
                <a
                  class="button is-medium is-outlined is-link has-text-link has-text-weight-semibold is-rounded"
                >
                  <i class="fas fa-spinner fa-spin"></i>
                </a>
              </div>
              <!-- Step 3 -->
              <hr />
              <p class="title is-size-5 has-text-success has-text-left">{{ $t("login.step-3") }}</p>
              <div>
                <div class="field">
                  <div
                    class="control has-icons-left has-icons-right"
                    style="width: 35vw; margin: 0 auto"
                  >
                    <input
                      v-model="inputCode"
                      class="input is-link is-medium has-text-centered is-expanded has-text-weight-semibold"
                      type="number"
                      placeholder="00"
                      v-on:keyup="checkCode"
                    />
                    <span class="icon is-small is-left">
                      <i class="fas fa-key"></i>
                    </span>
                  </div>
                </div>
                <progress class="progress is-danger" :value="timer" :max="maxTime" />
              </div>
            </div>
          </div>

          <br />
          <p class="has-text-danger" style="line-height:0.1em" v-if="error">{{ error }}</p>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "LoginLineModal",
  data() {
    return {
      inputCode: "",
      error: undefined,
      timer: 0.0,
      maxTime: 300,
      blurButton: true, // force blue button to re-render
      loginAttemptedAt: null
    };
  },
  computed: mapState(["magicLogin"]),
  watch: {
    magicLogin(m) {
      this.timer = 0; // reset timer whenever magicLogin object changes
      if (m != null) {
        this.startTimer(); // wait to start timer until not null
      }
    }
  },
  mounted() {
    // first clear magicLogin if exists and expired
    if (this.magicLoginAge() > this.maxTime && this.$store.state.magicLogin) {
      this.$store.commit("clearMagicLogin", "mounted");
    }
    // then start new magicLogin if there is none
    if (
      typeof this.$store.state.magicLogin !== "object" ||
      this.$store.state.magicLogin == null
    ) {
      this.startFourDigitLogin(); // get a login code on initial render
    } else {
      // else continue with timer
      this.startTimer();
    }
  },
  methods: {
    magicLoginAge() {
      return (new Date() - this.$store.getters.magicLoginCreatedAt) / 1000;
    },
    startTimer() {
      var interval = setInterval(() => {
        this.timer = this.magicLoginAge();
        if (this.timer > this.maxTime) {
          clearInterval(interval);
          this.$store.commit("clearMagicLogin", "startTimer - " + this.timer);
          this.closeModal();
        }
      }, 50);
    },
    startFourDigitLogin() {
      this.loginAttemptedAt = new Date();
      this.console("START 4-digit login");

      var loader = this.loadingDots();
      this.$store
        .dispatch("loginStart", { source: "line" }) // source: sms
        .then(() => {
          this.console("loginStart for LINE login SUCCESS");
          // this.sendSMS();
          // this.error = ""; // clear any previous errs
        })
        .catch(err => {
          this.apiError(err);
        })
        .finally(() => loader.hide());
    },
    closeModal() {
      this.inputCode = "";
      this.error = "";
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    onCopy(e) {
      // reset this button after click by turning it on/off quickly
      this.blurButton = false;
      this.$nextTick(() => {
        this.blurButton = true;
      });
      this.$swal({
        title: e.text,
        text: "Copied to clipboard!",
        showConfirmButton: false,
        timer: 1000
      });
    },
    onCopyGoToLine(e) {
      this.$swal({
        title: "Going to LINE...",
        html: `<strong>${e.text}</strong>&nbsp;Copied to clipboard!`,
        showConfirmButton: false,
        timer: 3000
      });
    },
    goToLine() {
      setTimeout(() => {
        window.location.href = process.env.VUE_APP_LINE;
      }, 1000);
    },
    checkCode() {
      this.console(
        `checkCode: ${this.$store.getters.secondCode} vs ${this.inputCode}`
      );
      if (this.$store.getters.secondCode === this.inputCode) {
        this.closeModal();
        var loader = this.loadingDots();
        this.$store
          .dispatch("fourDigitLoginSuccess")
          .then(() => {
            // this.loginSuccess();
            this.$swal({
              title: this.$t("login.success-title"),
              html: this.$t("login.success-text1") + " 🙏🏽",
              showConfirmButton: false,
              timer: 1500
            })
              .then(() => {
                if (!this.$store.getters.getUserMobile) {
                  this.setMobileNumber();
                }
              })
              .finally(() => loader.hide());
          })
          .catch(err => {
            this.apiError(err);
          });
        return;
      }
      if (this.inputCode.length >= 2) {
        this.error = "Incorrect code, please try again";
        this.$el.querySelector("input").classList.remove("is-link");
        this.$el.querySelector("input").classList.add("is-danger");
      }
      if (this.inputCode.length < 2) {
        this.error = "";
        this.$el.querySelector("input").classList.remove("is-danger");
        this.$el.querySelector("input").classList.add("is-link");
      }
    }
  }
};
</script>

<style scoped>
.modal-card-body {
  width: 95vw;
  margin: 0 auto;
  border-radius: 25px;
}
@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(247, 211, 8, 0.95);
  }
  100% {
    box-shadow: 0 0 0 20px rgba(247, 211, 8, 0);
  }
}
#friend-button {
  animation: shadow-pulse 1s 999;
}
</style>